import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import { Autocomplete, TextField } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

import { shopdata } from "../../assets/Griddata"; // Import dataset
import {
  LOCATION_API_01, SHOP_API_01
} from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
function ViewShop() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  // const [data, setData] = useState(null);
  const [data, setData] = useState([]);

  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [selectedLocCode, setSelectedLocCode] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, USERNAME, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  const goToPage = () => {
    navigate("/AddShop");
  };

  const goToPageview = () => {
    navigate("/GenerateQR");
  };

  // useEffect(() => {
  //   if (data) {
  //     const filtered = data.filter((item) =>
  //       item.RESTCODE.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //     setFilteredData(filtered);
  //   }
  // }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

  const handleItemClick = (id, actionText) => {
    const selectedItem = data.find((item) => item.RESTCODE == id);
    if (selectedItem) {
      if (actionText === "Edit") {
        navigate(`/AddShop`, { state: { selectedItem, actionText } });
      } else {
        navigate(`/GenerateQR`, { state: { selectedItem, actionText } });
      }
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (RESTCODE) => handleItemClick(RESTCODE, "Edit"),
    },
    {
      text: "Genarate QR",
      icon: <QrCodeScannerIcon />,
      onClick: (RESTCODE) => handleItemClick(RESTCODE, "Genarate QR"),
    },
  ];

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        RESTCODE: item.RESTCODE,
        RESTNAME: item.RESTNAME,
        BUSINESSTYPE: item.BUSINESSTYPE,
        DESCRIPTION: item.DESCRIPTION,
        ADDRESS1: item.ADDRESS1,
        ADDRESS2: item.ADDRESS2,
        ADDRESS3: item.ADDRESS3,
        HOTLINE: item.HOTLINE,
        FAX: item.FAX,
        EMAIL: item.EMAIL,
        BUSINESSTYPECODE: item.BUSINESSTYPECODE,
        SALESSTYLETYPE: item.SALESSTYLETYPE,
        ISCHAIN: item.ISCHAIN,
        OPRDATE: item.OPRDATE,
        LOCCODE: item.LOCCODE,
      }))
    : [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SHOP_API_01, "get", {
          COMPCODE: COMPCODE,
          GROUPCODE: GROUPCODE,
          USERNAME: USERNAME,
          // CATTYPE: "R",
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setFilteredData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result);
        console.log("Filtered Locations:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSelectionloc = (newValue) => {
    if (newValue && newValue.LOCCODE) {
      setSelectedLOC(newValue);
      setSelectedLocCode(newValue.LOCCODE);
    } else {
      setSelectedLocCode("");
      setSelectedLOC(null);
    }
  };

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
      setSelectedLocCode(dataloc[0].LOCCODE); // Set the first item's LOCCODE as the default
    }
  }, [dataloc, selectedLOC]);

  useEffect(() => {
    if (selectedLocCode) {
      const filtered = data.filter((item) => item.LOCCODE === selectedLocCode);
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [selectedLocCode, data]);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Shop</Link>
                <Link underline="none">View Shop</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
              >
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      sx={{ width: 300 }}
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Update the state correctly
                  }}
                  value={selectedLOC}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />

                <Button
                  onClick={goToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={shopdata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={shopdata.name}
          gridid="RESTCODE"
        />
      )}
    </div>
  );
}

export default ViewShop;
